import { takeEvery, fork, put, all } from 'redux-saga/effects'
import { Auth } from 'aws-amplify';
import i18n from 'i18next';

// Login Redux States
import { FORGET_PASSWORD, FORGET_PASSWORD_CONFIRMATION } from './actionTypes'
import { userForgetPasswordSuccess, userForgetPasswordError } from './actions'

import showToast from '../../../components/Common/viewNotification';

//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* forgetUser({ payload: { user, history } }) {
  try {
    yield Auth.forgotPassword(user.email);
    showToast(i18n.t('messageRegister:sendCode'), 'success');
    yield put(userForgetPasswordSuccess(i18n.t('messageRegister:sendCode')));
  } catch (error) {
    showToast(i18n.t('messageRegister:sendCodeError'), 'error');
    yield put(userForgetPasswordError(error.message));
  }
}

function* forgetUserConfirmation({ payload: { user, history } }) {
  try {
    yield Auth.forgotPasswordSubmit(
      user.email,
      user.confirmation,
      user.password
    );
    showToast(i18n.t('messageForgetPassword:forgetSuccess'), 'success');
    yield put(userForgetPasswordSuccess(i18n.t('messageForgetPassword:forgetSuccess')));
    history.push('/login');
  } catch (error) {
    showToast(error.message, 'error');
    yield put(userForgetPasswordError(error.message));
  }
}

export function* watchUserPasswordForget() {
  yield takeEvery(FORGET_PASSWORD, forgetUser)
  yield takeEvery(FORGET_PASSWORD_CONFIRMATION, forgetUserConfirmation)
}

function* forgetPasswordSaga() {
  yield all([fork(watchUserPasswordForget)])
}

export default forgetPasswordSaga
